// extracted by mini-css-extract-plugin
module.exports = {"clrBorder":"#ccc","root":"FormButtons_root__3v0Wu","topMargin":"FormButtons_topMargin___YuJi"};